import API from './api';
import { handleApiError } from './utilsService';

// Servicio para las categorías
const categoryService = {
  // Obtener todas las categorías
  getCategories: async (filters = {}) => {
    try {
      // Intentar obtener las categorías con un timeout más corto para la página de inicio
      const timeout = window.location.pathname === '/' ? 5000 : 30000;

      // Si estamos en la página de inicio y no hay filtros específicos, usar el endpoint de categorías activas
      if (window.location.pathname === '/' && Object.keys(filters).length === 0) {
        const response = await API.get('/categories/active', {
          timeout: timeout,
        });
        console.log('Categorías activas obtenidas para el home:', response.data);
        return response.data;
      }

      // Para otras páginas o con filtros, usar el endpoint completo
      const response = await API.get('/categories', {
        params: filters,
        timeout: timeout,
      });

      // Extraer las categorías del objeto de respuesta
      const data = response.data;
      if (data && data.categories) {
        return data.categories;
      }

      // Si la respuesta es directamente un array, devolverlo
      if (Array.isArray(data)) {
        return data;
      }

      console.warn('Formato de respuesta inesperado:', data);
      return [];
    } catch (error) {
      console.error('Error al obtener las categorías:', error);

      // Si estamos en la página de inicio, devolver un array vacío en lugar de propagar el error
      if (window.location.pathname === '/') {
        console.warn('Error en la página de inicio, devolviendo array vacío');
        return [];
      }

      // Para otras páginas, propagar el error normalmente
      throw handleApiError(error, 'Error al obtener las categorías');
    }
  },

  // Obtener categorías activas (específico para el home y páginas públicas)
  getActiveCategories: async () => {
    try {
      const response = await API.get('/categories/active', {
        timeout: 10000,
      });
      console.log('Categorías activas obtenidas:', response.data);
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error al obtener las categorías activas:', error);
      return [];
    }
  },

  // Obtener una categoría por ID
  getCategoryById: async (id) => {
    try {
      const response = await API.get(`/categories/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener la categoría');
    }
  },

  // Crear una nueva categoría (solo admin)
  createCategory: async (categoryData) => {
    try {
      const response = await API.post('/categories', categoryData);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al crear la categoría');
    }
  },

  // Actualizar una categoría (solo admin)
  updateCategory: async (id, categoryData) => {
    try {
      const response = await API.put(`/categories/${id}`, categoryData);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al actualizar la categoría');
    }
  },

  // Eliminar una categoría (solo admin)
  deleteCategory: async (id) => {
    try {
      const response = await API.delete(`/categories/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al eliminar la categoría');
    }
  },

  // Obtener estadísticas de categorías (solo admin)
  getCategoryStats: async () => {
    try {
      const response = await API.get('/categories/stats');
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener las estadísticas de categorías');
    }
  },

  // Obtener usuarios por categoría (solo admin)
  getUsersByCategory: async (categoryId) => {
    try {
      const response = await API.get(`/categories/${categoryId}/users`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener los usuarios de la categoría');
    }
  },

  // Obtener partidos por categoría
  getMatchesByCategory: async (categoryId, filters = {}) => {
    try {
      const response = await API.get(`/categories/${categoryId}/matches`, { params: filters });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener los partidos de la categoría');
    }
  },

  // NUEVOS métodos para año de nacimiento
  // Obtener categorías por año de nacimiento
  getCategoriesByBirthYear: async (year, gender = 'mixed') => {
    try {
      const response = await API.get(`/categories/birth-year/${year}`, {
        params: { gender }
      });
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error al obtener categorías por año de nacimiento:', error);
      throw handleApiError(error, 'Error al obtener categorías por año de nacimiento');
    }
  },

  // Obtener categorías por fecha de nacimiento
  getCategoriesByBirthDate: async (birthDate, gender = 'mixed') => {
    try {
      const response = await API.get(`/categories/birth-date/${birthDate}`, {
        params: { gender }
      });
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error al obtener categorías por fecha de nacimiento:', error);
      throw handleApiError(error, 'Error al obtener categorías por fecha de nacimiento');
    }
  },

  // Mantener método de edad para compatibilidad
  getCategoriesByAge: async (age) => {
    try {
      const response = await API.get(`/categories/age/${age}`);
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error al obtener categorías por edad:', error);
      throw handleApiError(error, 'Error al obtener categorías por edad');
    }
  },

  // Métodos adaptados para useCRUD hook
  getAll: (filters = {}) => {
    return categoryService.getCategories(filters);
  },

  create: (data) => {
    return categoryService.createCategory(data);
  },

  update: (id, data) => {
    return categoryService.updateCategory(id, data);
  },

  delete: (id) => {
    return categoryService.deleteCategory(id);
  },

  getById: (id) => {
    return categoryService.getCategoryById(id);
  }
};

export default categoryService;
